export default __webpack_public_path__ + "static/media/srisailamVisitEleven.a4a1009e.jpg";